export default __webpack_public_path__ + "static/media/arrow-right.ce99045a.svg";